import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	sorry: {
		id: 'partner.error',
		defaultMessage: 'Oops! Something went wrong.',
		description: 'Error sorry',
	},
	support: {
		id: 'partner.error.support',
		defaultMessage: 'Please try again or <supportlink>Visit Our Support Page</supportlink>',
		description: 'Error support link',
	},
	errorCode: {
		id: 'partner.error.errorCode',
		defaultMessage: 'Error Code: {error}',
		description: 'Error code text',
	},
	participantId: {
		id: 'partner.error.participantId',
		defaultMessage: 'Participant ID: {pid}',
		description: 'Error participant id',
	},
	partnerNotFound: {
		id: 'partner.error.partnerNotFound',
		defaultMessage:
			'This is not an active signup page. Please check your link and try again. If you continue to receive this error, please reach out to your Benefits Administrator to confirm you have the correct website link.',
		description: "Error message received when accessing a page for a Calm Partner that doesn't exist",
	},
	userHasSubscription: {
		id: 'partner.error.userAlreadySubscribed',
		defaultMessage:
			'You already have a Calm Premium subscription, so you can’t activate this offer right now. <managesubscriptionlink>You can learn more about your own subscription here.</managesubscriptionlink>',
		description: 'Error message that shows when a user is trying to redeem when they are already subscribed',
	},
	invalidToken: {
		id: 'partner.error.invalidToken',
		defaultMessage:
			'Please try following the instructions provided to you by {partnerName} again. If you continue to receive this error, please <supportlink>Visit Our Support Page.</supportlink>',
		description:
			'Error message when the user tries to access the partner signup page without a valid access token.',
	},
	invalidOfferCodeId: {
		id: 'partner.error.invalidOfferCodeId',
		defaultMessage: 'This offer code is not valid or has already been used.',
		description: 'Error message when the user tries to use an invalid offer code embedded link.',
	},
	ssoMissingTokenMultipleLinks: {
		id: 'partner.error.ssoMissingTokenMultipleLinks',
		defaultMessage:
			'Welcome to Calm! Single Sign On is required for {partnerName}. Please use the links below to redirect to the SSO login page: {links}',
		description:
			'A user can land on the SSO page without the proper SSO credentials, so we present multiple links to redirect to the correct login page',
	},
	ssoMissingTokenFriendly: {
		id: 'partner.error.ssoMissingTokenFriendly',
		defaultMessage:
			'Welcome to Calm! Single Sign On is required for {partnerName}. <anchor>Please click this link to redirect to the SSO login page.</anchor>',
		description:
			'A user can land on the SSO page without the proper SSO credentials, so we redirect to the correct login page',
	},
	ssoMissingToken: {
		id: 'partner.error.ssoMissingToken',
		defaultMessage:
			'Single Sign On is required for {partnerName}. <anchor>Please click this link to redirect to the SSO login page.</anchor>',
		description:
			'A user can land on the SSO page without the proper SSO credentials, so we redirect to the correct login page',
	},
	ssoMissingTokenNoRenewUrl: {
		id: 'partner.error.ssoMissingToken.noRenewUrl',
		defaultMessage:
			'Single Sign On is required for {partnerName}. Please reach out to your Benefits Administrator for further information.',
		description:
			'A user can land on the SSO page without the proper SSO credentials, and in rare cases there is nowhere to take them',
	},
	alreadyRedeemed: {
		id: 'dtcPartnership.error.alreadyRedeemedEligibility',
		defaultMessage:
			'We are sorry, but this offer code has already been used to redeem a subscription. Please try following the instructions provided to you by {partnerName} again. If you continue to receive this error, please <supportlink>Visit Our Support Page.</supportlink>',
		description: 'User cannot redeem the offer a second time',
	},
	userCannotTrial: {
		id: 'dtcPartnership.error.cannot.trial',
		defaultMessage:
			'We are sorry, but you are not eligible for this offer. This offer is only available for customers who have not previously used a Calm Premium trial. If you think you’ve received this message in error, please reach out to Calm’s Support team <supportlink>here</supportlink> for assistance',
		description: 'User cannot redeem the offer a second time',
	},
	userOutsideRegion: {
		id: 'dtcPartnership.error.outside.us',
		defaultMessage:
			'We are sorry, but you are not eligible for this offer. This offer is only available for customers within the United States. If you think you’ve received this message in error, please reach out to Calm’s Support team <supportlink>here</supportlink> for assistance',
		description: 'User cannot redeem the offer if only good in the US and user is not in US',
	},
});
